var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page basic-data" },
    [
      _c(
        "el-container",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-aside",
            {
              staticClass: "inner-box",
              staticStyle: {
                width: "fit-content",
                height: "calc(100vh - 210px)",
                "overflow-x": "hidden",
                "margin-top": "60px"
              }
            },
            [
              _c(
                "el-radio-group",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" },
                  attrs: { no: "navigationBars" },
                  on: { change: _vm.barChange },
                  model: {
                    value: _vm.currentBar,
                    callback: function($$v) {
                      _vm.currentBar = $$v
                    },
                    expression: "currentBar"
                  }
                },
                _vm._l(_vm.navigationBars, function(item, index) {
                  return _c(
                    "el-radio",
                    {
                      key: index,
                      staticStyle: { "line-height": "30px" },
                      attrs: { label: item.value }
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-main",
            { staticStyle: { padding: "0px", flex: "1" } },
            [
              _vm.currentBar === "Continent"
                ? _c("continent", {
                    ref: "continent",
                    attrs: { no: "continent" }
                  })
                : _vm._e(),
              _vm.currentBar === "Region"
                ? _c("region", { ref: "region", attrs: { no: "region" } })
                : _vm._e(),
              _vm.currentBar === "MscServiceCode"
                ? _c("msc-service", {
                    ref: "mscService",
                    attrs: { no: "mscService" }
                  })
                : _vm._e(),
              _vm.currentBar === "Network"
                ? _c("network", { ref: "network", attrs: { no: "network" } })
                : _vm._e(),
              _vm.currentBar === "Currency"
                ? _c("currency", { ref: "currency", attrs: { no: "currency" } })
                : _vm._e(),
              _vm.currentBar === "EQType"
                ? _c("eq-type", { ref: "eqType", attrs: { no: "eqType" } })
                : _vm._e(),
              _vm.currentBar === "Packing"
                ? _c("packing", { ref: "packing", attrs: { no: "packing" } })
                : _vm._e(),
              _vm.currentBar === "OrderFormType"
                ? _c("order-form-type", {
                    ref: "orderFormType",
                    attrs: { no: "orderFormType" }
                  })
                : _vm._e(),
              _vm.currentBar === "CargoType"
                ? _c("cargo-type", {
                    ref: "cargoType",
                    attrs: { no: "cargoType" }
                  })
                : _vm._e(),
              _vm.currentBar === "IncoTerm"
                ? _c("inco-term", {
                    ref: "incoTerm",
                    attrs: { no: "incoTerm" }
                  })
                : _vm._e(),
              _vm.currentBar === "ShippingTerm"
                ? _c("shipping-term", {
                    ref: "shippingTerm",
                    attrs: { no: "shippingTerm" }
                  })
                : _vm._e(),
              _vm.currentBar === "PaymentTerm"
                ? _c("payment-term", {
                    ref: "paymentTerm",
                    attrs: { no: "paymentTerm" }
                  })
                : _vm._e(),
              _vm.currentBar === "TradeTerm"
                ? _c("trade-term", {
                    ref: "tradeTerm",
                    attrs: { no: "tradeTerm" }
                  })
                : _vm._e(),
              _vm.currentBar === "GpExplainTitle"
                ? _c("gp-explain-title", {
                    ref: "gpExplainTitle",
                    attrs: { no: "gpExplainTitle" }
                  })
                : _vm._e(),
              _vm.currentBar === "CustomsMode"
                ? _c("customs-mode", {
                    ref: "customsMode",
                    attrs: { no: "customsMode" }
                  })
                : _vm._e(),
              _vm.currentBar === "PriceAirService"
                ? _c("price-air-service", {
                    ref: "priceAirService",
                    attrs: { no: "priceAirService" }
                  })
                : _vm._e(),
              _vm.currentBar === "PortGroup"
                ? _c("port-group", {
                    ref: "portGroup",
                    attrs: { no: "portGroup" }
                  })
                : _vm._e(),
              _vm.currentBar === "OtherChargeItem"
                ? _c("other-charge-item", {
                    ref: "otherChargeItem",
                    attrs: { no: "otherChargeItem" }
                  })
                : _vm._e(),
              _vm.currentBar === "CustomerType"
                ? _c("customer-type", {
                    ref: "customerType",
                    attrs: { no: "customerType" }
                  })
                : _vm._e(),
              _vm.currentBar === "AppraisalCategory"
                ? _c("appraisal-category", {
                    ref: "appraisalCategory",
                    attrs: { no: "appraisalCategory" }
                  })
                : _vm._e(),
              _vm.currentBar === "BlMode"
                ? _c("bl-mode", { ref: "blMode", attrs: { no: "blMode" } })
                : _vm._e(),
              _vm.currentBar === "CutomJobType"
                ? _c("cutom-job-type", {
                    ref: "cutomJobType",
                    attrs: { no: "cutomJobType" }
                  })
                : _vm._e(),
              _vm.currentBar === "TransmitFileType"
                ? _c("transmit-file-type", {
                    ref: "transmitFileType",
                    attrs: { no: "transmitFileType" }
                  })
                : _vm._e(),
              _vm.currentBar === "CommissionRule"
                ? _c("commission-rule", {
                    ref: "commissionRule",
                    attrs: { no: "commissionRule" }
                  })
                : _vm._e(),
              _vm.currentBar === "RailwayLine"
                ? _c("railway-line", {
                    ref: "railwayLine",
                    attrs: { no: "railwayLine" }
                  })
                : _vm._e(),
              _vm.currentBar === "ValueAddedServices"
                ? _c("value-added-services", {
                    ref: "valueAddedServices",
                    attrs: { no: "valueAddedServices" }
                  })
                : _vm._e(),
              _vm.currentBar === "ChargeUnit"
                ? _c("charge-unit", {
                    ref: "chargeUnit",
                    attrs: { no: "chargeUnit" }
                  })
                : _vm._e(),
              _vm.currentBar === "DangerousGoods"
                ? _c("dangerous-goods", {
                    ref: "dangerousGoods",
                    attrs: { no: "dangerousGoods" }
                  })
                : _vm._e(),
              _vm.currentBar === "CargoInformation"
                ? _c("cargo-information", {
                    ref: "cargoInformation",
                    attrs: { no: "cargoInformation" }
                  })
                : _vm._e(),
              _vm.currentBar === "PropulsionType"
                ? _c("propulsion-type", {
                    ref: "propulsionType",
                    attrs: { no: "propulsionType" }
                  })
                : _vm._e(),
              _vm.currentBar === "CustomerSource"
                ? _c("customer-source", {
                    ref: "customerSource",
                    attrs: { no: "customerSource" }
                  })
                : _vm._e(),
              _vm.currentBar === "ReasonForJudgment"
                ? _c("reason-for-judgment", {
                    ref: "reasonForJudgment",
                    attrs: { no: "reasonForJudgment" }
                  })
                : _vm._e(),
              _vm.currentBar === "CTT"
                ? _c("transport-type", { ref: "ctt", attrs: { no: "" } })
                : _vm._e(),
              _vm.currentBar === "VehicleModel"
                ? _c("vehicle-model", {
                    ref: "vehicleModel",
                    attrs: { no: "vehicleModel" }
                  })
                : _vm._e(),
              _vm.currentBar === "CooperationType"
                ? _c("cooperation-type", {
                    ref: "cooperationType",
                    attrs: { no: "cooperationType" }
                  })
                : _vm._e(),
              _vm.currentBar === "AirplaneModel"
                ? _c("airplane-model", {
                    ref: "airplaneModel",
                    attrs: { no: "airplaneModel" }
                  })
                : _vm._e(),
              _vm.currentBar === "AirplaneContainer"
                ? _c("airplane-container", {
                    ref: "airplaneContainer",
                    attrs: { no: "airplaneContainer" }
                  })
                : _vm._e(),
              _vm.currentBar === "CustomEqType"
                ? _c("custom-eq-type", {
                    ref: "customEqType",
                    attrs: { no: "customEqType" }
                  })
                : _vm._e(),
              _vm.currentBar === "ChargeGroup"
                ? _c("charge-group", {
                    ref: "chargeGroup",
                    attrs: { no: "chargeGroup" }
                  })
                : _vm._e(),
              _vm.currentBar === "CustomsDeclarationType"
                ? _c("customs-declaration-type", {
                    ref: "customsDeclarationType",
                    attrs: { no: "customsDeclarationType" }
                  })
                : _vm._e(),
              _vm.currentBar === "AirCargoTerminal"
                ? _c("air-cargo-terminal", {
                    ref: "airCargoTerminal",
                    attrs: { no: "airCargoTerminal" }
                  })
                : _vm._e(),
              _vm.currentBar === "GeneralCargoWarehouse"
                ? _c("general-cargo-warehouse", {
                    ref: "generalCargoWarehouse",
                    attrs: { no: "generalCargoWarehouse" }
                  })
                : _vm._e(),
              _vm.currentBar === "WarehouseStorageLocation"
                ? _c("warehouse-storage-location", {
                    ref: "warehouseStorageLocation",
                    attrs: { no: "warehouseStorageLocation" }
                  })
                : _vm._e(),
              _vm.currentBar === "PalletConfiguration"
                ? _c("pallet-configuration", {
                    ref: "palletConfiguration",
                    attrs: { no: "palletConfiguration" }
                  })
                : _vm._e(),
              _vm.currentBar === "WoodenPackageType"
                ? _c("wooden-package-type", {
                    ref: "woodenPackageType",
                    attrs: { no: "woodenPackageType" }
                  })
                : _vm._e(),
              _vm.currentBar === "StatisticArea"
                ? _c("statistic-area", {
                    ref: "statisticArea",
                    attrs: { no: "statisticArea" }
                  })
                : _vm._e(),
              _vm.currentBar === "DangerousGoodPackage"
                ? _c("dangerous-good-package", {
                    ref: "dangerousGoodPackage",
                    attrs: { no: "dangerousGoodPackage" }
                  })
                : _vm._e(),
              _vm.currentBar === "TransportSource"
                ? _c("transport-source", {
                    ref: "transportSource",
                    attrs: { no: "transportSource" }
                  })
                : _vm._e(),
              _vm.currentBar === "TransportationType"
                ? _c("transportation-type", {
                    ref: "transportationType",
                    attrs: { no: "transportationType" }
                  })
                : _vm._e(),
              _vm.currentBar === "PaymentMethod"
                ? _c("payment-method", {
                    ref: "paymentMethod",
                    attrs: { no: "paymentMethod" }
                  })
                : _vm._e(),
              _vm.currentBar === "SpecialOperationCode"
                ? _c("special-operation-code", {
                    ref: "specialOperationCode",
                    attrs: { no: "specialOperationCode" }
                  })
                : _vm._e(),
              _vm.currentBar === "TransshipmentTransportationMode"
                ? _c("transshipment-transportation-mode", {
                    ref: "transshipmentTransportationMode",
                    attrs: { no: "transshipmentTransportationMode" }
                  })
                : _vm._e(),
              _vm.currentBar === "AirServiceProduct"
                ? _c("air-service-product", {
                    ref: "airServiceProduct",
                    attrs: { no: "airServiceProduct" }
                  })
                : _vm._e(),
              _vm.currentBar === "Commerce"
                ? _c("commerce", { ref: "commerce", attrs: { no: "commerce" } })
                : _vm._e(),
              _vm.currentBar === "Town"
                ? _c("town", { ref: "town", attrs: { no: "town" } })
                : _vm._e(),
              _vm.currentBar === "PostalCode"
                ? _c("postalCode", {
                    ref: "postalCode",
                    attrs: { no: "postalCode" }
                  })
                : _vm._e(),
              _vm.currentBar === "BranchFleet"
                ? _c("branch-fleet", {
                    ref: "branchFleet",
                    attrs: { no: "branchFleet" }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }